<template>
  <v-dialog v-model="showDialogCartDatePicker" width="95%" max-width="400px">
    <v-date-picker
      v-model="searchDate"
      :events="itemAvailabilityMarkers"
      color="blue darken-2"
      event-color="green lighten-1"
      full-width
      @change="showDialogCartDatePicker = false"
    >
      <v-spacer></v-spacer>
      <v-btn class="blue--text text--darken-1" @click="clear" text>Clear</v-btn>
      <v-btn
        class="blue--text text--darken-2"
        @click="showDialogCartDatePicker = false"
        text
        >Cancel</v-btn
      >
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

import _uniq from 'lodash/uniq'
import _reduce from 'lodash/reduce'
import _get from 'lodash/get'

export default {
  name: 'DialogCartDatePicker',
  components: {},
  data() {
    return {}
  },
  methods: {
    clear() {
      this.searchDate = null
      this.showDialogCartDatePicker = false
    },
  },
  computed: {
    ...mapFields('cart', ['searchDate', 'showDialogCartDatePicker']),
    ...mapGetters('itemAndSection', ['getSections']),
    itemAvailabilityMarkers() {
      return _uniq(
        _reduce(
          this.sections,
          (dates, section) => [
            ...dates,
            ..._get(section, 'items', []).map((i) => i.date),
          ],
          []
        )
      )
    }, // itemAvailabilityMarkers
    sections() {
      return this.getSections
    }, // sections
  },
  watch: {
    searchDate() {
      this.$scrollTo('#menu-form', 700, { offset: -100 })
    }, // searchDate
  },
}
</script>
